import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactGA from 'react-ga';

import MobileNav from './components/MobileNav';
import Container from './components/Container';
import LeftNav from './components/LeftNav';
import Footer from './components/Footer';

import './styles/App.scss';

class App extends Component {
  initializeReactGA() {
    ReactGA.initialize('UA-36865561-1');
    ReactGA.pageview('/homepage');
  }

  render() {
    return (
      <Router id="outer-container">
        <MobileNav />
        <div className="app" id="page-wrap">
          <LeftNav />
          <Container />
          <Footer />
        </div>
        {this.initializeReactGA()}
      </Router>
    );
  }
}
export default App;
